import { FieldConfig } from '../dynamic-form/models/field-config.interface';
import { Pagination } from './pagination';

export interface CMSFormDefinition {
    name: string;
    definition: FieldConfig[];
    symbol: string;
}

export class CMSForm {
    id = 0;
    name = '';
    active = false;
    definitions: string | CMSFormDefinition[] = '';
    templates?: number[] = [];
    type = '';
}

export class CMSFormResponse {
    message = '';
    pagination = new Pagination;
    form = new CMSForm;
    forms: CMSForm[];
}
